/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { keys } from 'lodash';
import { Helmet } from 'react-helmet-async';

import favicon from 'assets/images/favicon.ico';
// import logo from 'assets/images/logo.svg';
import logo from 'assets/images/logos/spareFoot-social-logo.webp';

export default function PageMetadata({
	title,
	meta = {},
	og = {},
	twitter = {},
	links = [],
	structuredData, // eslint-disable-line no-unused-vars
	noindex = false,
	filteredPage = false,
}) {
	const canonicalLinks = links.filter(
		(link) => link.rel === 'canonical' && !link.href?.includes('undefined')
	);
	const otherLinks = links.filter(
		(link) => link.rel !== 'canonical' &&
			!(link.href?.includes('undefined') || link.content?.includes('undefined'))
	);

	return (
		<Helmet>
			{canonicalLinks.map((link, i) => (
				<link {...link} key={`canonical-${i}`} />
			))}
			<link
				rel="icon"
				href={favicon}
			/>
			<meta
				property="og:site_name"
				content="Sparefoot"
			/>
			<title key="title">{title}</title>
			<meta
				key="og:title"
				property="og:title"
				content={title}
			/>
			<meta
				property="og:image"
				content={logo}
			/>
			{keys(og).map((key) => (
				<meta
					property={`og:${key}`}
					content={og[key]}
					key={key}
				/>
			))}
			{keys(meta)
				.filter((key) => key !== 'robots')
				.map((key) => (
					<meta
						name={key}
						content={meta[key]}
						key={key}
					/>
				))}
			{keys(twitter).map((key) => (
				<meta
					name={`twitter:${key}`}
					content={twitter[key]}
					key={`twitter:${key}`}
				/>
			))}
			{otherLinks.map((link, i) => (
				<link {...link} key={`link-${i}`} />
			))}
			{/* Always render robots tag so react-helmet can update it when
			   filteredPage transitions from true→false. Conditionally omitting
			   the tag caused Helmet to leave stale noindex in the DOM. */}
			<meta
				name="robots"
				content={(!!noindex || filteredPage) ? 'noindex, nofollow' : 'index, follow'}
			/>
		</Helmet>
	);
}

PageMetadata.propTypes = {
	title: PropTypes.string,
	meta: PropTypes.object,
	og: PropTypes.object,
	twitter: PropTypes.object,
	links: PropTypes.arrayOf(PropTypes.object),
	structuredData: PropTypes.object,
	noindex: PropTypes.bool,
	filteredPage: PropTypes.bool
};

